import { useTranslation } from 'react-i18next';
import slugify from 'slugify';
import { Recipe } from '../../graphql/generated/api-graphql';
import { ArticleRecipesBlockProps } from '../../components/molecules/ArticleRecipesBlock';
import { fixURL } from '../../helpers/StringHelpers';
import { wediaImagesTransform } from '../Common/wedia';
import { Icons } from '../../components/atoms/Icon';
import Router, { routes } from '../../routes/Router';
import { ActionButtonVariant } from '../../components/atoms/ActionButton/styled';
const useArticleRecipes = (data?: Recipe[]): ArticleRecipesBlockProps | null => {
  const {
    t
  } = useTranslation();
  if (!data) {
    return null;
  }
  return {
    recipes: data?.map(recipe => ({
      title: recipe?.title ?? '',
      anchor: slugify(recipe?.title ?? ''),
      htmlProps: recipe?.introduction ? {
        text: fixURL(recipe.introduction)
      } : undefined,
      pictureProps: recipe?.thumbnail01 ? {
        maxWidth: 910,
        width: 910,
        height: 400,
        withHD: true,
        alt: recipe?.thumbnail01.alt ?? '',
        images: [...(recipe?.thumbnail01 ? wediaImagesTransform(recipe?.thumbnail01) ?? [] : [])].filter(Boolean)
      } : undefined,
      mobilePictureProps: recipe?.thumbnail01 ? {
        maxWidth: 370,
        width: 370,
        height: 200,
        withHD: true,
        alt: recipe?.thumbnail01.alt ?? '',
        images: [...(recipe?.thumbnail01 ? wediaImagesTransform(recipe?.thumbnail01) ?? [] : [])].filter(Boolean)
      } : undefined,
      buttons: [{
        label: t('learn_more'),
        iconProps: {
          icon: Icons.arrowRight
        },
        variant: ActionButtonVariant.secondary,
        iconPosition: 'right',
        href: Router.getRouteUrl(routes.recipe, {
          slug: recipe.slug ?? ''
        })
      }]
    })) ?? []
  };
};
export default useArticleRecipes;